import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import axios from "axios";
import apiConfig from '../apiConfig';
import jwt_decode from "jwt-decode";

// ── Styles ───────────────────────────────────────────────────────────────────
const S = {
  card: {
    background: '#FFFFFF',
    borderRadius: '12px',
    padding: '18px 20px',
    border: '1px solid #EFEFEF',
    boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
    transition: 'box-shadow 0.15s, transform 0.15s',
    cursor: 'default',
  },
  cardIcon: (bg, color) => ({
    width: '38px',
    height: '38px',
    borderRadius: '10px',
    background: bg,
    color,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '17px',
    marginBottom: '12px',
  }),
  cardLabel: {
    fontSize: '11px',
    fontWeight: 700,
    color: '#BBBBBB',
    textTransform: 'uppercase',
    letterSpacing: '0.07em',
    marginBottom: '4px',
  },
  cardValue: {
    fontSize: '22px',
    fontWeight: 800,
    color: '#111',
    letterSpacing: '-0.5px',
  },
  cardUnit: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#999',
    marginLeft: '3px',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
    gap: '16px',
    marginBottom: '22px',
  },
};

// ── Stat Card ────────────────────────────────────────────────────────────────
const StatCard = ({ label, value, unit, iconClass, iconBg, iconColor, linkTo }) => {
  const inner = (
    <div
      style={S.card}
      onMouseEnter={e => {
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.04)';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      <div style={S.cardIcon(iconBg, iconColor)}>
        <i className="material-icons" style={{ fontSize: '18px' }}>{iconClass}</i>
      </div>
      <div style={S.cardLabel}>{label}</div>
      <div style={S.cardValue}>
        {value ?? '—'}
        {unit && <span style={S.cardUnit}>{unit}</span>}
      </div>
    </div>
  );
  return linkTo
    ? <Link to={linkTo} style={{ textDecoration: 'none' }}>{inner}</Link>
    : inner;
};

// ── Main Component ───────────────────────────────────────────────────────────
const RefferedList = () => {
  const history  = useHistory();
  const params   = new URLSearchParams(history.location.search);
  const puser_Id = params.get("userId");

  // ── Auth ──────────────────────────────────────────────────────────────────
  const token        = localStorage.getItem("jwtToken");
  const decodedToken = jwt_decode(token);

  if (token && decodedToken.exp < Date.now() / 1000) {
    localStorage.removeItem("jwtToken");
    window.location.href = "/login";
  }

  // ── State ─────────────────────────────────────────────────────────────────
  const [userData, setUserData] = useState(null);
  const [agentDashboardData, setAgentDashboardData] = useState({
    received_from_admin:          0,
    total_transfer_agents:        0,
    total_downline_balance:       0,
    total_agent_downline_balance: 0,
    total_agent_downline_count:   0,
    total_downline_count:         0,
    total_user_deposit_balance:   0,
    total_user_withdraw:          0,
    total_bonus:                  0,
    total_active_user:            0,
  });

  // ── Derived values ────────────────────────────────────────────────────────
  const bal               = userData?.balance           ?? 0;
  const commision_balance = userData?.commision_balance ?? 0;

  // ── Fetch ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (!puser_Id) return;

    axios.get(`${apiConfig.baseURL}/api/users/shows/${puser_Id}`)
      .then(res => setUserData(res.data))
      .catch(console.error);

    axios.get(`${apiConfig.baseURL}/api/agent/agentData/${puser_Id}`)
      .then(res => setAgentDashboardData(res.data))
      .catch(console.error);
  }, [puser_Id]);

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">
            <div className="card">

              {/* ── Header ── */}
              <div className="card-header">
                <h4 className="card-title">Active User List</h4>
              </div>

              {/* ── Stat Cards ── */}
              <div className="card-body">
                <div style={S.grid}>
                  <StatCard
                    label="Current Balance"
                    value={bal}
                    unit="TK"
                    iconClass="account_balance_wallet"
                    iconBg="#EBF3FF"
                    iconColor="#0066CC"
                  />
                  <StatCard
                    label="Withdraw Balance"
                    value={commision_balance}
                    unit="TK"
                    iconClass="percent"
                    iconBg="#FCE4EC"
                    iconColor="#C2185B"
                    linkTo="affiliate-index"
                  />
                  <StatCard
                    label="Commission Balance"
                    value={((agentDashboardData.total_downline_balance || 0) * 0.05).toFixed(2)}
                    unit="TK"
                    iconClass="percent"
                    iconBg="#FCE4EC"
                    iconColor="#C2185B"
                    linkTo="affiliate-index"
                  />
                  <StatCard
                    label="Affiliate Commission"
                    value={agentDashboardData.total_downline_balance || 0}
                    unit="TK"
                    iconClass="percent"
                    iconBg="#FCE4EC"
                    iconColor="#C2185B"
                    linkTo="affiliate-index"
                  />
                  {/* <StatCard
                    label="Affiliate Total Deposit"
                    value={agentDashboardData.total_user_deposit_balance || 0}
                    unit="TK"
                    iconClass="arrow_downward"
                    iconBg="#E8F5E9"
                    iconColor="#2E7D32"
                  /> 
                  <StatCard
                    label="Affiliate Total Withdraw"
                    value={agentDashboardData.total_user_withdraw || 0}
                    unit="TK"
                    iconClass="arrow_upward"
                    iconBg="#FFF3E0"
                    iconColor="#E65100"
                  />*/}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default RefferedList;